<template>
    <div class="content">
        <vue-img class="icon-img" src='https://jusewebapp.zmelo.com/netHospital/404.png' />
        <div class="remind">哦吼！！页面找不到了，尝试刷新试试。</div>
        <div class="click-item" @click="refresh">刷新页面</div>
    </div>
</template>

<script>
export default {
  name: 'netFailure',
  data () {
    return {

    };
  },
  title () {
    return {
      title: '网络错误',
    };
  },
  methods: {
    refresh () {
      location.replace(location.href);
    },
  },
  mounted () {

  },
};
</script>

<style scoped lang="less">
    @import "../../../static/css/fontSize";
    .content{
        height: 100vh;
        padding-top: 200*@width;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #FAFAFA;
    }
    .icon-img{
        width: 344*@width;
        height: 216*@width;
        margin-bottom: 71*@width;
    }
    .remind{
        font-size:28*@width;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(68,68,64,1);
        margin-bottom: 126*@width;
    }
    .click-item{
        width:280*@width;
        height:88*@width;
        background:rgba(255,255,255,1);
        border-radius:4*@width;
        border:1px solid rgba(8,121,245,1);
        text-align: center;
        font-size:28*@width;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(8,121,245,1);
        line-height:88*@width;
    }
</style>



// WEBPACK FOOTER //
// netFailure.vue